import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Spring, config } from 'react-spring/renderprops'
import { useInView } from 'react-intersection-observer'
import { Box } from 'components/atoms/Layout'
import Container from 'components/atoms/Container'
import { H3, Text } from 'components/atoms/Typography'
import { COLORS } from 'config/constants'
import bushCorner from 'assets/svg/bush-corner.svg'

const AnimatedNumber = ({ to, suffix }) => (
  <Spring to={{ number: to }} config={config.molasses}>
    {({ number }) => (
      <Text
        as="span"
        fontWeight="bold"
        color="white"
        fontSize={{ mobile: 'h3', tablet: 'h2', desktop: 'h1' }}
      >
        {Math.round(number)}
        {!!number && suffix}
      </Text>
    )}
  </Spring>
)

AnimatedNumber.propTypes = {
  to: PropTypes.number.isRequired,
  suffix: PropTypes.string,
}

const NumbersWrapper = styled.div`
  display: flex;
  > * + * {
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
`

const Numbers = () => {
  const [observedEl, isInView] = useInView({
    threshold: 1,
    triggerOnce: true,
  })

  return (
    <Box
      background={{
        mobile: COLORS.POSEIDON,
        tablet: `${COLORS.POSEIDON} url("${bushCorner}") left bottom / auto 50% no-repeat;`,
      }}
      py="xl"
    >
      <Container.Narrow ref={observedEl} textAlign="center">
        <H3 color="white">Our achievements</H3>
        <Text color="white" mb="l">
          Crescent Heights has helped many people in the past. Now we want to
          help you!
        </Text>
        <NumbersWrapper>
          <Box flex="1">
            <AnimatedNumber to={isInView ? 40 : 0} suffix="K+" />
            <Text fontSize="s" fontWeight="semi_bold">
              Built & Sold
            </Text>
          </Box>
          <Box flex="1" textAlign="center">
            <AnimatedNumber to={isInView ? 75 : 0} suffix="K+" />
            <Text fontSize="s" fontWeight="semi_bold">
              Housed
            </Text>
          </Box>
          <Box flex="1" textAlign="center">
            <AnimatedNumber to={isInView ? 45 : 0} />
            <Text fontSize="s" fontWeight="semi_bold">
              Cities
            </Text>
          </Box>
        </NumbersWrapper>
      </Container.Narrow>
    </Box>
  )
}

export default Numbers
